import { FormFieldsConfig } from "pages/components/Form/FormEntities";

const ContactConfig: FormFieldsConfig = {
  phone: {
    constraints: [
      "required",
      {
        message: {
          name: "string_equal_length",
          params: {
            length: "10",
          },
        },
        validation: (value: string, values: any) =>
          value === "" || value.length === 10,
      },
    ],
  },
  mobile: {
    constraints: [
      "required",
      {
        message: {
          name: "string_equal_length",
          params: {
            length: "10",
          },
        },
        validation: (value: string, values: any) =>
          value === "" || value.length === 10,
      },
    ],
  },
  email: {
    constraints: ["required", "email"],
  },
};

export default ContactConfig;
